module.exports = __webpack_public_path__ + "img/bg1-2.c5bc86ee.png";